import moment from 'moment'
import { get } from 'lodash'

const status = {
  scheduled: 'Agendado',
  attended: 'Atendido',
  absent: 'Ausente',
  in_attendance: 'Em atendimento'
}

const prepareSchedule = schedule => {
  schedule.covenant = get(schedule, 'covenant.name', 'Não informado')
  schedule.patient = get(schedule, 'patient.name')
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.status = get(status, schedule.status, schedule.status)

  return schedule
}

const prepareShow = agenda => {
  agenda.schedules = agenda.schedules.map(prepareSchedule)

  return agenda
}

export default {
  setFirstAgenda (data) {
    if (data.length > 0) {
      this.agenda_id = data[0].id
    }
  },
  selectedAgenda (agenda) {
    if (!this.agenda_id) {
      return
    }
    this.$resource.get(this.agenda_id + '/today/details')
      .then(({data}) => {
        this.agenda = prepareShow(data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/active-agenda/resources/methods.js